import React from "react"
import { Badge } from "reactstrap"
import ClientInvoiceStatusConstants from "constants/ClientInvoiceStatusConstants"

const ClientInvoiceStatusBadge = props => {
    const { value } = props
    return (
        <Badge color={MapInvoiceStatusColour(value)}>
            {MapInvoiceStatusLabel(value)}
        </Badge>
    )
}

const MapInvoiceStatusLabel = value => {
    switch (value) {
        case ClientInvoiceStatusConstants.DRAFT:
            return "DRAFT"
        case ClientInvoiceStatusConstants.PAID:
            return "PAID"
        case ClientInvoiceStatusConstants.UNPAID:
            return "UNPAID"
        default:
            return "UNKNOWN"
    }
}

const MapInvoiceStatusColour = value => {
    switch (value) {
        case ClientInvoiceStatusConstants.DRAFT:
        case ClientInvoiceStatusConstants.UNPAID:
            return "warning"
        case ClientInvoiceStatusConstants.PAID:
            return "success"
        default:
            return "default"
    }
}

export default ClientInvoiceStatusBadge